const en = {
  ID_VOICE_CHAT_TAB_WORLD: "World Chat",
  ID_VOICE_CHAT_TAB_PRIVATE: "Personal Chat",
  ID_VOICE_CHAT_LIST_FOLLOWER: "Follower",
  ID_VOICE_CHAT_LIST_FOLLOWING: "Following",
  ID_VOICE_CHAT_LIST_WORLD: "User",
  ID_VOICE_CHAT_LIST_SEARCH: "Search",
  ID_VOICE_CHAT_PRIVATE_CHAT_REQUEST: "Request",
  ID_VOICE_CHAT_PRIVATE_CHAT_REQUEST_ING: "Requesting",
  ID_VOICE_CHAT_PRIVATE_CHAT_CALLING: "ongoing",
  ID_VOICE_CHAT_FOOTER_ENTER_BTN: "Join",
  ID_VOICE_CHAT_FOOTER_CLOSE_BTN: "End",
  ID_VOICE_CHAT_WORLD_CHATTING: "World vocie chat ongoing",
  ID_VOICE_CHAT_FLOATING_CHATTING: "I'm chatting with {user} in 1:1 voice chat",
  ID_VOICE_CHAT_FLOATING_CHATTING_APPLY: "Applied for 1:1 voice chat with {user}",
  ID_VOICE_CHAT_FLOATING_CHATTING_ACCEPT: "{user} accepted the 1:1 voice chat request.",
  ID_VOICE_CHAT_FLOATING_CHATTING_DENY: "{user} declined the 1:1 voice chat request.",
  ID_VOICE_CHAT_FLOATING_CHATTING_REAPPLY: "You can ask {user} again in {min} minutes and {sec} seconds",
  ID_VOICE_CHAT_FLOATING_CHATTING_DIFFERENT: "{user} is in the middle of another voice chat.",
  ID_VOICE_CHAT_FLOATING_CHATTING_BLOCK_ALERT: "Please unblock the chat for {user} and try again.",
  ID_VOICE_CHAT_FLOATING_CHATTING_BLOCK: "Should I block all {user}'s chat?",
  ID_VOICE_CHAT_FLOATING_CHATTING_REQUEST: "{user} requested 1:1 voice chat. \n It is automatically rejected when the time expires.",
  ID_VOICE_CHAT_PRIVATE_CHAT_ENTER: "Should I end the world voice chat and request the {user} for a 1:1 voice chat",
  ID_VOICE_CHAT_WORLD_CHAT_ENTER: "Should I end 1:1 voice chat and go back to world voice chat?",
  ID_VOICE_CHAT_PRIVATE_CHAT_END: "1:1 voice chat has ended.",
  ID_VOICE_CHAT_SEARCH: "Search",
  ID_VOICE_CHAT_SEARCH_PLACEHOLDER: "There are no search results.",
  ID_VOICE_CHAT_LIST_PLACEHOLDER_WORLD: "World voice chat is in progress. \n Join the voice chat now.",
  ID_VOICE_CHAT_VERIFIED_POPUP_INFO: "Voice chat is available only after completing\nboth email and mobile phone authentication.",
  ID_VOICE_CHAT_VERIFIED_POPUP_CONFIRM: "Authenticate",
};
export default en;
